<template>
  <table class="info-table table table-sm">
    <tr>
      <th class="border-top-0">{{$t('Attribute')}}</th>
      <th class="border-top-0">{{$t('Old')}}</th>
      <th class="border-top-0">{{$t('New')}}</th>
    </tr>
    <tr>
      <td>{{$t('Increments')}}</td>
      <td v-html="oldData()"></td>
      <td v-html="newData()"></td>
    </tr>
  </table>
</template>

<script>
  export default {
    name: "ActivityIncrementsTable",
    props: {
      activity: {
        type: Object,
        required: true
      }
    },
    methods: {
      oldData() {
        if (!this.activity.old_data) {
          return '';
        }
        return this.getIncrementsData(this.activity.old_data);
      },
      newData() {
        if (!this.activity.data) {
          return '';
        }
        return this.getIncrementsData(this.activity.data);
      },
      getIncrementsData(data) {
        let returnValue = '';

        data.forEach((increment) => {
          if (!increment.max) {
            returnValue += this.$i18n.t('Increment: {increment}', {
              increment: increment.increment,
              max: increment.max,
            });
          } else {
            returnValue += this.$i18n.t('Increment: {increment} | Upto: {max}', {
              increment: increment.increment,
              max: increment.max,
            });
          }
          returnValue += "<br>";
        });

        return returnValue;
      }
    }
  }
</script>

<style scoped>

</style>
